export const overrideClipboardData = (event) => {
    event.preventDefault();
    event.clipboardData?.setData('text/plain', '');
    event.clipboardData?.setData('text/html', '');
    event.stopPropagation();
};
export async function configureIrmCapabilities(componentDivSync, informationProtectionService, resolvedUrl, mipCache, tracker) {
    tracker?.markSubActivityStart('ConfigureIrmCapabilities');
    let blockCopyListenerEnabled = false;
    let blockPrintListenerEnabled = false;
    // Fluid Iframe in ComponentUX scenario
    const fluidIframe = componentDivSync.firstElementChild instanceof HTMLIFrameElement ? componentDivSync.firstElementChild : undefined;
    const iframeBlockPrintStyle = fluidIframe?.contentDocument?.createElement('style');
    if (iframeBlockPrintStyle) {
        iframeBlockPrintStyle.textContent = '@media print { * {display: none;} }';
    }
    const blockPrintStyle = componentDivSync.ownerDocument.createElement('style');
    blockPrintStyle.textContent = '@media print { * {display: none;} }';
    const enablePrint = () => {
        if (blockPrintListenerEnabled) {
            if (iframeBlockPrintStyle) {
                fluidIframe?.contentDocument?.head.removeChild(iframeBlockPrintStyle);
            }
            componentDivSync.ownerDocument.head.removeChild(blockPrintStyle);
            blockPrintListenerEnabled = false;
        }
    };
    const disablePrint = () => {
        if (!blockPrintListenerEnabled) {
            if (iframeBlockPrintStyle) {
                fluidIframe?.contentDocument?.head.appendChild(iframeBlockPrintStyle);
            }
            componentDivSync.ownerDocument.head.appendChild(blockPrintStyle);
            blockPrintListenerEnabled = true;
        }
    };
    const disableCutCopy = (componentDivSync) => {
        if (!blockCopyListenerEnabled) {
            // Add an event listener to execute the disableClipboardCopy function on a copy event.
            // The third parameter allows us to execute the callback on event capture, meaning we can
            // block copy call from propagating to component level if the disable flight is active
            componentDivSync.addEventListener('copy', overrideClipboardData, true /* useCapture */);
            componentDivSync.addEventListener('cut', overrideClipboardData, true /* useCapture */);
            blockCopyListenerEnabled = true;
        }
    };
    const enableCutCopy = (componentDivSync) => {
        if (blockCopyListenerEnabled) {
            componentDivSync.removeEventListener('copy', overrideClipboardData, true);
            componentDivSync.removeEventListener('cut', overrideClipboardData, true);
            blockCopyListenerEnabled = false;
        }
    };
    const onIrmCapabilitiesChanged = (irmCapabilities) => {
        irmCapabilities.canExtract ? enableCutCopy(componentDivSync) : disableCutCopy(componentDivSync);
        irmCapabilities.canPrint ? enablePrint() : disablePrint();
    };
    const getIrmCapabilities = async () => {
        const irmCapabilities = await informationProtectionService.getIrmInformation(resolvedUrl);
        if (irmCapabilities) {
            onIrmCapabilitiesChanged(irmCapabilities);
        }
    };
    informationProtectionService.on('IrmCapabilitiesChanged', onIrmCapabilitiesChanged);
    // Update the irmCapabilities from cache if available
    if (mipCache?.irmCapabilities) {
        onIrmCapabilitiesChanged(mipCache.irmCapabilities);
        getIrmCapabilities().catch(() => { });
    }
    else {
        await getIrmCapabilities();
    }
    tracker?.markSubActivityEnd('ConfigureIrmCapabilities');
}
//# sourceMappingURL=configureIrmCapabilities.js.map